<h1 mat-dialog-title *ngIf="!data.isConfirm">Zugang zurückgesetzt</h1>
<h1 mat-dialog-title *ngIf="data.isConfirm">Erfolgreich bestätigt</h1>
<mat-dialog-content>
  <div class="icon-bar">
    <mat-icon>check</mat-icon>
  </div>

  <p *ngIf="!data.isConfirm">
    Es wurde eine E-Mail an <strong>{{data.email}}</strong> versendet,<br>
    sofern bereits ein Zugang für diese E-Mail-Adresse existiert.<br>
    Bitte prüfen Sie Ihren E-Mail-Eingang und eventuell auch Ihren Spam-Ordner.
  </p>

  <p *ngIf="data.isConfirm">
    Ihr Zugang oder Ihr Passwort wurde erfolgreich zurückgesetzt.<br>
    Es wurde eine E-Mail an <strong>{{data.email}}</strong> versendet,<br>
    in der Sie Ihr neues Passwort oder einen Link zum Aktivieren Ihres Zugangs finden.<br>
    Bitte folgen Sie den Anweisungen in der E-Mail und prüfen Sie eventuell auch Ihren Spam-Ordner.
  </p>

</mat-dialog-content>
<div mat-dialog-actions>
  <button mat-button (click)="goToLogin()" cdkFocusInitial>Zurück zum Login</button>
</div>
